{
  "header": {
    "title": "Biblioteca de preguntas",
    "description": "Gestiona tus categorías y preguntas de retroalimentación",
    "addCategoryButton": "Agregar categoría"
  },
  "searchInput": {
    "placeholder": "Buscar preguntas"
  },
  "delete": {
    "title": "Eliminar categoría",
    "description": "¿Estás seguro de que deseas eliminar esta categoría? Esta acción no se puede deshacer y todas las preguntas y respuestas asociadas se eliminarán permanentemente.",
    "deleteButton": "Eliminar categoría",
    "cancelButton": "Cancelar"
  },
  "translationOverview": {
    "title": "Traducción a otros idiomas",
    "description": "Usamos traducción por IA, por lo que el resultado puede contener errores"
  },
  "detailsPage": {
    "header": {
      "backButton": "Volver a categorías de preguntas",
      "questionsCount": "{{questionsCount}} preguntas",
      "addQuestionButton": "Agregar pregunta"
    },
    "searchInput": {
      "placeholder": "Buscar preguntas"
    },
    "sortDropdown": {
      "triggerLabel": "Ordenar por",
      "options": {
        "questionQuantity": "Cantidad de preguntas",
        "fromNewestToOldest": "De más nuevo a más antiguo",
        "fromOldestToNewest": "De más antiguo a más nuevo"
      }
    },
    "delete": {
      "title": "Eliminar pregunta",
      "description": "¿Estás seguro de que deseas eliminar esta pregunta? Esta acción no se puede deshacer y todas las respuestas asociadas se eliminarán permanentemente.",
      "deleteButton": "Eliminar pregunta",
      "cancelButton": "Cancelar"
    },
    "translationOverview": {
      "title": "Traducción a otros idiomas",
      "description": "Usamos traducción por IA, por lo que el resultado puede contener errores"
    }
  }
}
